export default __webpack_public_path__ + "static/device-31c0eb26c5d6c4199ec8ba150122bfcf.png";